import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import apiReducer from './slices/api/api'
import loadindReducer from './slices/loading/loading'
import userDetailsReducer from './slices/user/userDetails'
import geomanReducer from './slices/geoman/geoman'
import viabilityStudyReducer from './slices/viabilityStudy/viabilityStudy'
import studiesReducer from './slices/dashboard/studies'
import modalReducer from './slices/modal';
import checkoutReducer from './slices/checkout/checkout';
import calculatorReducer from './slices/viabilityCalculator/viabilityCalculator'
import usersReducer from './slices/dashboard/users'
import admConfigurationsReducer from './slices/admConfigurations/admConfigurations';

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  api: apiReducer,
  userDetails: userDetailsReducer,
  geoman: geomanReducer,
  loading: loadindReducer,
  viabilityStudy: viabilityStudyReducer,
  studies: studiesReducer,
  users: usersReducer,
  modal: modalReducer,
  checkout: checkoutReducer,
  calculator: calculatorReducer,
  admConfigurations: admConfigurationsReducer,
});

export { rootPersistConfig, rootReducer };
